import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { styled, IconButton, alpha, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Add } from '@mui/icons-material';
import getCreationMenuConfig from './configs';
import { canAccessItem } from '../../NavV2/utils/navPermissions';
import renderIcon from '../../shared/icons';

const CreationMenuButton = styled(IconButton)(({ theme }) => ({
    color: alpha(theme.palette.secondary.main, 0.8),
    height: '42px',
    width: '42px',
    borderRadius: '4.5px',
    svg: {
        height: '32px',
        width: '32px',
    },
    '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
}));

const CreationMenu = ({ user }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const history = useHistory();
    const config = getCreationMenuConfig();
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (path) => {
        history.push(path);
        handleClose();
    };

    const accessibleItems = config.filter((item) => canAccessItem(user, item));

    if (accessibleItems.length === 0) return null;

    return (
        <>
            <CreationMenuButton onClick={handleOpen}>
                <Add />
            </CreationMenuButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }} // wrap
            >
                {accessibleItems.map((item) => (
                    <MenuItem
                        key={item.id}
                        onClick={() => handleSelect(item.path)}
                        sx={(theme) => ({
                            '& .MuiListItemIcon-root': {
                                minWidth: 0,
                                marginRight: 1.25,
                                color: alpha(theme.palette.secondary.main, 0.64),
                            },
                            '&:hover': {
                                backgroundColor: alpha(theme.palette.primary.main, 0.08),
                            },
                        })}
                    >
                        <ListItemIcon>{renderIcon(item.icon)}</ListItemIcon>
                        <ListItemText primary={item.title} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default CreationMenu;
